import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef, HostListener } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryService } from '../../services/inventory.service';
import { Location } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { VendorService } from '../../services/vendor.service';

@Component({
	selector: 'app-inventory-promos',
	templateUrl: './inventory-promos.component.html',
	styleUrls: ['./inventory-promos.component.scss'],
	animations: [
		trigger('grow', [
			transition(':enter', [
				style({ height: '0', width: '0' }),
				animate('150ms', style({ width: '*', height: '*' })),
				animate('150ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				animate('150ms', style({ width: '0', height: '0' })),
				animate('150ms', style({ opacity: 0 }))
			])
		]),
	],
})
export class InventoryPromosComponent implements OnInit {

	@ViewChild('vendorFieldWrap') vendorFieldWrap: ElementRef;

	vendorSearchText = '';
	includeInactiveVendor = new FormControl(false);
	vendorPanelOpen = false;

	itemSearchControl = new UntypedFormControl('');
	categoryControl = new UntypedFormControl([]);
	productLineControl = new UntypedFormControl([]);
	searchpromo = new UntypedFormControl('');
	searchmix = new UntypedFormControl('');
	hideExpiredPromos = new UntypedFormControl(true);
	hideExpiredMMs = new UntypedFormControl(true);
	searching = false;
	inventorysearching: any;
	itemsearchsubscription: any;
	include_disabled = new UntypedFormControl(false);

	items: any = [];
	activemm: any;;
	allitems: any = [];
	newmm: any = false;
	exists: any = false;
	color: any = '';
	config: any = [];
	user: any = [];
	promoitems: any = false;
	promos: any = false;
	mms: any = false;
	mm: any = false;
	itemForm: UntypedFormGroup;
	itemMMForm: UntypedFormGroup;
	vendorsearchsubscription: any = false;
	editingpromo: any = false;
	newpromo: any = false;
	editingmm: any = false;
	vendorresults: any = [];
	properties: any = false;
	saving: any = false;
	mmitems: any = false;
	triggersearch: any = false;
	allpromos: any = [];
	brands: any = [];
	promo_types = [
		{
			value: 3,
			label: 'Mix And Match Child Price with additional Items'
		},
		{
			value: 2,
			label: 'Discounted Total, Mix And Match Items'
		},
		{
			value: 4,
			label: 'Child Priced Promo'
		//bottom up
		},
	]



	sortedPromos = [];
	loadingPromos = true;

	sortColumn = '';
	sortDirection = 'asc';
	sortedMMs = [];
	loadingMMs = true;
	mmSortColumn = '';
	mmSortDirection = 'asc';

	constructor(private vendorService: VendorService, private globalsService: GlobalsService, private route: ActivatedRoute, private inventoryService: InventoryService, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private fb: FormBuilder, private globalSearchService: GlobalSearchService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		});

		this.color = this.globalSearchService.getColor();
		this.globalSearchService.user.subscribe((results: any) => {
			if (results) {
				this.user = results.user;
			}
		});
	}

	ngOnInit(): void {
		const filter = []
		this.loadingPromos = true;
		this.inventoryService.getPromos(filter).subscribe({
			next: r => {
				this.allpromos = r.promos;
				this.applyPromoFilters();
				this.loadingPromos = false;
			},
			error: () => {
				this.loadingPromos = false;
			}
		});

		this.inventoryService.getMfgs().subscribe(r => {
			this.brands = r
		});

		this.loadingMMs = true;
		this.inventoryService.getMixAndMatch(filter).subscribe({
			next: r => {
				this.mms = r;
				this.setMMForm();
				this.applyMMFilters();
				this.loadingMMs = false;
			},
			error: () => {
				this.loadingMMs = false;
			}
		});

		this.globalsService.getItemSetup().subscribe((results: any) => {
			this.properties = results
			this.setForm();
		});

		this.includeInactiveVendor.valueChanges.subscribe(() => {
			const t = (this.vendorSearchText || '').trim();
			if (t) {
				this.vendorSearch(t);
			}
		});

	}

	removeExclusion(item: any) {

		const ob = this.mm.exlusions.filter((i: any) => {
			return i.stockid == item.stockid;
		})[0];

		const index = this.mm.exlusions.indexOf(ob);
		this.mm.exlusions.splice(index, 1);
		this.triggersearch = this.mm.exlusions;

	}

	exludeItem(item: any) {
		const index = this.mmitems.indexOf(item);
		if (index >= 0) {
			this.mmitems.splice(index, 1);
			this.mm.exlusions.push(item);
		}
	}

	showResults(event: any) {
		this.triggersearch = false;
		this.mmitems = event;
	}

	vendorSearch(value: any) {
		if (this.vendorsearchsubscription) {
			this.vendorsearchsubscription.unsubscribe();
		}

		this.vendorsearchsubscription = this.vendorService.getVendorSearch(value, !!this.includeInactiveVendor.value).subscribe((results: any) => {
			this.vendorresults = results;
		});
	}

	syncVendorDisplay() {
		const v = this.itemForm?.get('supplierno')?.value;
		if (v == null || v === '') {
			this.vendorSearchText = '';
			return;
		}
		if (typeof v === 'object' && v.suppname != null) {
			const id = v.supplierid != null ? String(v.supplierid) + ' — ' : '';
			this.vendorSearchText = id + v.suppname;
			return;
		}
		this.vendorSearchText = String(v);
	}

	onVendorInput(ev: Event) {
		const el = ev.target as HTMLInputElement;
		this.vendorSearchText = el.value;
		this.vendorPanelOpen = true;
		this.itemForm.get('supplierno').setValue('');
		this.vendorSearch(el.value);
	}

	selectVendor(v: any) {
		this.itemForm.get('supplierno').setValue(v);
		this.vendorSearchText = (v.supplierid != null ? String(v.supplierid) + ' — ' : '') + (v.suppname || '');
		this.vendorresults = [];
		this.vendorPanelOpen = false;
	}

	onVendorFocus() {
		this.vendorPanelOpen = true;
		if (this.vendorSearchText && this.vendorresults.length === 0) {
			this.vendorSearch(this.vendorSearchText);
		}
	}

	onVendorBlur() {
		setTimeout(() => {
			this.vendorPanelOpen = false;
		}, 200);
	}

	@HostListener('document:click', ['$event'])
	onDocumentClick(ev: MouseEvent) {
		if (this.vendorFieldWrap?.nativeElement && !this.vendorFieldWrap.nativeElement.contains(ev.target as Node)) {
			this.vendorPanelOpen = false;
		}
	}

	setForm() {

		const today = new Date();
		const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

		this.itemForm = this.fb.group({
			//image: [''],
			supplierno: [''],
			stockid: ['', [Validators.required, Validators.maxLength(20)]],
			name: ['', [Validators.required]],
			brand: ['', [Validators.required]],
			description: [''],
			longdescription: [''],
			categoryid: ['', [Validators.required]],
			lineid: ['', [Validators.required]],
			mbflag: ['C', [Validators.required]],
			taxcatid: ['2', [Validators.required]],
			units: ['each', [Validators.required]],
			supplier: [''],
			mfgpart: [''],
			promotype: [3],
			discount: [0, ],
			price: [0.00, ],
			discounttype: ['', ],
			cost: [0, [Validators.required]],
			options: [1, [Validators.required]],
			enddate: [lastDayOfMonth, [Validators.required]],
			startdate: [today, [Validators.required]],
		});

		this.itemForm.get('lineid').valueChanges.subscribe(newValue => {
			let suggested = newValue + this.itemForm.get('mfgpart').value

			//todo make this dynamic: break by % % and fill in variable names
			if (this.config.stockidformat && !this.editingpromo) {
				switch (this.config.stockidformat) {
				case '%categoryid%lineid%mfgpart%':
					suggested = this.itemForm.get('categoryid').value + this.itemForm.get('lineid').value + newValue;
					break;
				default:
					suggested = newValue + '-' + this.itemForm.get('mfgpart').value;
					break;
				}
				this.itemForm.get('stockid').setValue(suggested);
			}

			
		});

		this.itemForm.get('mfgpart').valueChanges.subscribe(newValue => {
			let suggested = this.itemForm.get('lineid').value + '-' + newValue

			//todo make this dynamic: break by % % and fill in variable names
			if (this.config.stockidformat && !this.editingpromo) {
				switch (this.config.stockidformat) {
				case '%categoryid%lineid%mfgpart%':
					suggested = this.itemForm.get('categoryid').value + this.itemForm.get('lineid').value + newValue;
					break;
				default:
					suggested = this.itemForm.get('lineid').value + '-' + newValue;
					break;
				}
				this.itemForm.get('stockid').setValue(suggested);
			}

			
		});

		this.itemForm.get('name').valueChanges.subscribe(newValue => {
			this.itemForm.get('description').setValue(newValue);
			this.itemForm.get('longdescription').setValue(newValue);
		});

		this.itemForm.get('brand').valueChanges.subscribe(r => {
			this.updateProductLines();
		});
	}

	clearForm() {
		this.itemSearchControl.setValue('');
		this.allitems = [];
	}

	updateProductLines() {

		const data = {
			brands: this.itemForm.get('brand').value
		}

		this.inventoryService.getBrandProductlines(data).subscribe((r: any) => {
			this.properties.productlines = r;

			if (r[0]) {
				this.inventoryService.getSupplierFromProductLine(r[0].line_field).subscribe(supp => {
					this.itemForm.get('supplierno').setValue(supp[0]);
				});
			}
		});
	}

	setMMForm() {

		const today = new Date();
		//var priorDate = new Date(new Date().setDate(today.getDate() - 365));
		const priorDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
		const nextDate = new Date(today.getFullYear(), today.getMonth() + 2, 0);


		this.itemMMForm = this.fb.group({
			//image: [''],
			stockid: ['', [Validators.required, Validators.maxLength(20)]],
			name: ['', [Validators.required]],
			ceiling: ['', [Validators.required]],
			floor: ['', [Validators.required]],
			subtotal: ['', [Validators.required]], //subtotal?
			startdate: [priorDate, [Validators.required]],
			enddate: [nextDate, [Validators.required]],

		});

		this.triggersearch = false;
	}

	removePromo(mm: any) {
		const filter = [];
		if (!confirm('Delete Promo - ' + mm.name + '?')) {
			return;
		}
		this.inventoryService.removePromo(mm).subscribe((results: any) => {
			if (results && results.success && results.action === 'discontinued' && results.stockid) {
				alert(
					'This promo has stock movement history for ' +
						results.stockid +
						'. The promo was removed from the list and that product was marked discontinued (the stock record was kept for history).'
				);
			}
			this.inventoryService.getPromos(filter).subscribe(r => {
				this.promos = r.promos;
				this.sortedPromos = this.promos;
				this.allpromos = r.promos;
				this.sortedPromos = r.promos;
			});
		});
	}

	removeMM(mm:any) {
		if(confirm('Delete Mix and Match ?')){
			const data = {
				selected: mm
			}

			this.inventoryService.removeMM(data).subscribe(r => {
				this.mms = r;
				this.sortedMMs = r;
			});
		}
	}

	loadMM(mm: any) {

		const filters = { mmid: mm.mmid }
		this.setMMForm();
		this.inventoryService.getMix(filters).subscribe(r => {
			this.exists = true;
			this.mm = r;
			this.editingmm = r;
			this.newmm = false
			this.itemMMForm.get('stockid').setValue(mm.stockid);
			this.itemMMForm.get('name').setValue(mm.name);
			this.itemMMForm.get('ceiling').setValue(mm.ceiling);
			this.itemMMForm.get('floor').setValue(mm.floor);
			this.itemMMForm.get('startdate').setValue(new Date(mm.start_date));
			this.itemMMForm.get('enddate').setValue(new Date(mm.stop_date));
			this.itemMMForm.get('subtotal').setValue(r.price)
			this.triggersearch = false;
		});


	}

	loadPromo(promo: any) {

		this.editingpromo = promo;


		//
		// this.itemForm = this.fb.group({
		// 	//image: [''],
		// 	supplierno: [''],
		// 	stockid: ['', [Validators.required,Validators.maxLength(20)]],
		// 	name: ['', [Validators.required]],
		// 	brand: ['', [Validators.required]],
		// 	description: [''],
		// 	longdescription: [''],
		// 	categoryid: ['', [Validators.required]],
		// 	lineid: ['', [Validators.required]],
		// 	mbflag: ['C', [Validators.required]],
		// 	taxcatid: ['2', [Validators.required]],
		// 	units: ['each', [Validators.required]],
		// 	supplier: [''],
		// 	mfgpart: [''],
		// 	promotype: [3],
		// 	discount: [0,],
		// 	price: [0.00,],
		// 	discounttype: ['',],
		// 	cost: [0,[Validators.required]],
		// 	options: [1, [Validators.required]],
		// 	enddate: [lastDayOfMonth,[Validators.required]],
		// 	startdate: [today,[Validators.required]],
		// });
		//
		this.itemForm.get('stockid').setValue(promo.stockid);
		this.itemForm.get('name').setValue(promo.name);
		this.itemForm.get('description').setValue(promo.description);
		this.itemForm.get('longdescription').setValue(promo.definition.longdescription);
		this.itemForm.get('price').setValue(promo.price);
		this.itemForm.get('categoryid').setValue(promo.definition.categoryid);
		this.itemForm.get('lineid').setValue(promo.definition.lineid);
		this.itemForm.get('mfgpart').setValue(promo.definition.mfgpart);
		this.itemForm.get('brand').setValue(promo.brand.manufacturer_id);
		this.itemForm.get('supplierno').setValue(promo.vendor);
		this.itemForm.get('promotype').setValue(promo.type);
		this.itemForm.get('startdate').setValue(new Date(promo.startdate));
		this.itemForm.get('enddate').setValue(new Date(promo.enddate));

		this.promoitems = promo.products || [];
		this.ensurePromoItemEditBindings(this.promoitems);
		this.syncVendorDisplay();
	}

	/** BOM kit component lines are managed with the parent item; keep read-only. */
	isPromoKitComponentLine(p: any): boolean {
		return p && p.typedesc === 'Kit Item';
	}

	private ensurePromoItemEditBindings(items: any[] | false | null | undefined): void {
		if (!Array.isArray(items)) {
			return;
		}
		for (const p of items) {
			if (!p || p._promoEditBound || this.isPromoKitComponentLine(p)) {
				continue;
			}
			const price = parseFloat(p.price as string);
			const disc = parseFloat(p.discount as string);
			p._editPrice = Number.isFinite(price) ? price : 0;
			p._discPct = Number.isFinite(disc) ? +(disc * 100).toFixed(4) : 0;
			p._editQty = parseInt(p.qty, 10) || 1;
			p._promoEditBound = true;
		}
	}

	private normalizePromoItemRowStatic(p: any): any {
		const price = parseFloat(p.price as string);
		const disc = parseFloat(p.discount as string);
		const qty = parseInt(p.qty, 10);
		return {
			item: p.item,
			price: Number.isFinite(price) ? price.toFixed(2) : '0.00',
			discount: Number.isFinite(disc) ? disc.toFixed(8) : '0.00000000',
			qty: Number.isFinite(qty) && qty >= 1 ? qty : 1,
			type: parseInt(p.type, 10) || 1,
			max: p.max != null ? parseInt(p.max, 10) : 0,
			description: p.description,
			typedesc: p.typedesc,
		};
	}

	normalizePromoItemsForSave(): any[] {
		if (!Array.isArray(this.promoitems)) {
			return [];
		}
		return this.promoitems.map((p) => {
			if (this.isPromoKitComponentLine(p)) {
				return this.normalizePromoItemRowStatic(p);
			}
			const price = parseFloat(p._editPrice as string);
			const discPct = parseFloat(p._discPct as string);
			const qty = parseInt(p._editQty as string, 10);
			return {
				item: p.item,
				price: Number.isFinite(price) ? price.toFixed(2) : '0.00',
				discount: Number.isFinite(discPct)
					? (Math.max(0, Math.min(100, discPct)) / 100).toFixed(8)
					: '0.00000000',
				qty: Number.isFinite(qty) && qty >= 1 ? qty : 1,
				type: parseInt(p.type, 10) || 1,
				max: p.max != null ? parseInt(p.max, 10) : 0,
				description: p.description,
				typedesc: p.typedesc,
			};
		});
	}

	stripSlashes(input) {
		return input.replace(/\\(.)/mg, '$1');
	}

	noNewLines(input: any) {
		return this.stripSlashes(input.replace(/[^\x20-\x7E]/gmi, ' ').trim().replace(/\\n/g, ' '));
	}

	financial(x) {

		if (Number.isNaN(x)) {
			x = 0
		}

		return parseFloat(Number.parseFloat(x).toFixed(2));
	}

	back(): void {
		this.location.back()
	}

	displayFn(vendorid: any): string {

		if (!vendorid) {
			return '';
		}

		return vendorid.suppname;

	}

	ngOnChanges(changes: any) {}

	private indexInMulti(arr: any[] | null | undefined, val: any): number {
		if (!Array.isArray(arr)) {
			return -1;
		}
		return arr.findIndex((x) => x === val || String(x) === String(val));
	}

	isCategorySelected(val: any): boolean {
		return this.indexInMulti(this.categoryControl.value, val) >= 0;
	}

	toggleCategory(val: any, checked: boolean): void {
		const arr = [...(this.categoryControl.value || [])];
		const i = this.indexInMulti(arr, val);
		if (checked && i < 0) {
			arr.push(val);
		}
		if (!checked && i >= 0) {
			arr.splice(i, 1);
		}
		this.categoryControl.setValue(arr);
	}

	selectAllCategories(): void {
		const list = this.properties?.categories;
		if (!Array.isArray(list)) {
			this.categoryControl.setValue([]);
			return;
		}
		this.categoryControl.setValue(list.map((c: any) => c.value));
	}

	selectNoneCategories(): void {
		this.categoryControl.setValue([]);
	}

	isProductLineSelected(val: any): boolean {
		return this.indexInMulti(this.productLineControl.value, val) >= 0;
	}

	toggleProductLine(val: any, checked: boolean): void {
		const arr = [...(this.productLineControl.value || [])];
		const i = this.indexInMulti(arr, val);
		if (checked && i < 0) {
			arr.push(val);
		}
		if (!checked && i >= 0) {
			arr.splice(i, 1);
		}
		this.productLineControl.setValue(arr);
	}

	selectAllProductLines(): void {
		const list = this.properties?.productlines;
		if (!Array.isArray(list)) {
			this.productLineControl.setValue([]);
			return;
		}
		this.productLineControl.setValue(list.map((p: any) => p.value));
	}

	selectNoneProductLines(): void {
		this.productLineControl.setValue([]);
	}

	onCategoryCheckboxChange(val: any, ev: Event): void {
		const t = ev.target as HTMLInputElement;
		this.toggleCategory(val, t.checked);
	}

	onProductLineCheckboxChange(val: any, ev: Event): void {
		const t = ev.target as HTMLInputElement;
		this.toggleProductLine(val, t.checked);
	}

	searchItems() {
		this.searching = true;

		if (this.inventorysearching) {
			this.inventorysearching.unsubscribe()
		}

		const cat = this.categoryControl.value;
		const pl = this.productLineControl.value;
		const search = {
			stockid: this.itemSearchControl.value,
			category: Array.isArray(cat) && cat.length === 0 ? '' : cat,
			productlines: Array.isArray(pl) && pl.length === 0 ? '' : pl,
			discontinued: this.include_disabled.value,
			promotype: this.itemForm.get('promotype').value

		}

		this.inventorysearching = this.inventoryService.promolookup(search).subscribe((items: any) => {
			let list = items || [];
			if (list && !Array.isArray(list)) {
				list = Object.keys(list).map((k) => list[k]);
			}
			for (const it of list) {
				if (it.quantity == null || it.quantity === '') {
					it.quantity = 1;
				}
			}
			this.allitems = list;
			this.searching = false;
			this.items = list;
		});
	}



	removePromoItem(item: any) {
		const payload = {
			parent: this.itemForm.get('stockid').value,
			child: item,
		}

		this.inventoryService.removePromoItem(payload).subscribe((results: any) => {
			this.promoitems = results.bomitems;
			this.ensurePromoItemEditBindings(this.promoitems);
		});
	}

	saveMm(data: any) {

		const payload = {
			mixandmatch: this.itemMMForm.value,
			rules: data,
			mmid: this.mm.mmid
		}

		this.saving = true;

		this.inventoryService.saveMM(payload).subscribe((results: any) => {
			this.saving = false;
			this.promoitems = results.bomitems
		});

	}

	createMM() {

		const payload = {
			mixandmatch: this.itemMMForm.value,
		}

		this.saving = true;
		this.inventoryService.createMM(payload).subscribe((results: any) => {
			this.saving = false;
			if (results.success) {
				this.loadMM(results.details)
			}
		});
	}

	addPromo() {

		//if(this.itemForm.valid) {
		const payload = {
			promo: this.itemForm.value,
			promoitems: this.normalizePromoItemsForSave(),
		}


		const filter = []
		this.saving = true;


		this.inventoryService.savePromo(payload).subscribe((results: any) => {
			this.saving = false;
			this.inventoryService.getPromos(filter).subscribe(r => {
				this.promos = r.promos;
				this.sortedPromos = this.promos
				this.allpromos = r.promos;
				const reload = this.promos.filter(ra => {
					return ra.promoid == this.editingpromo.promoid
				})[0];
				if (reload) {
					this.editingpromo = reload;
					this.promoitems = reload.products || [];
					this.ensurePromoItemEditBindings(this.promoitems);
				}
				if (this.newpromo) {
					this.newpromo = false;

					const newitem = this.promos.filter(ra => {
						return ra.stockid == this.itemForm.get('stockid').value
					})[0];
					if (newitem) {
						this.editingpromo = newitem;
						this.promoitems = newitem.products || [];
						this.ensurePromoItemEditBindings(this.promoitems);
					}

				}
			});

		});
		//}
	}

	addPrommoItem(data: any) {

		const payload = {
			parent: this.itemForm.get('stockid').value,
			child: data,
		}

		this.inventoryService.addToPromo(payload).subscribe((results: any) => {
			if (!results.success) {
				this.globalSearchService.showNotification(results.message, 'danger', 'bottom', 'right');
			} else {
				this.globalSearchService.showNotification('Added', 'success', 'bottom', 'right');
			}
			this.promoitems = results.bomitems;
			this.ensurePromoItemEditBindings(this.promoitems);
		});

	}

	viewItem(row: any) {
		this.allitems = [];
		this.items = [];
		this.itemSearchControl.setValue('');
		this.router.navigate(['/inventory/view/' + row.stockid])
	}

	toggleNewMM() {
		this.newmm = true;
		this.editingmm = false;
	}

	isExpiredDate(dateVal: any): boolean {
		if (!dateVal) return false;
		const parsed = new Date(dateVal);
		if (isNaN(parsed.getTime())) return false;
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		return parsed < today;
	}

	applyPromoFilters() {
		let results = this.allpromos || [];
		if (this.hideExpiredPromos.value) {
			results = results.filter(p => !this.isExpiredDate(p.enddate || p.end_date));
		}
		const search = this.searchpromo.value;
		if (search) {
			results = this.globalSearchService.filterItem(results, search, 'stockid,start_date,stop_date,name,products');
		}
		this.promos = results;
		this.sortedPromos = results;
	}

	searchPromos(search) {
		this.applyPromoFilters();
	}

	toggleExpiredPromos() {
		this.applyPromoFilters();
	}

	applyMMFilters() {
		let results = this.mms || [];
		if (this.hideExpiredMMs.value) {
			results = results.filter(p => !this.isExpiredDate(p.stop_date));
		}
		const search = this.searchmix.value;
		if (search) {
			results = this.globalSearchService.filterItem(results, search, 'stockid,start_date,stop_date,name,products');
		}
		this.sortedMMs = results;
	}

	searchMix(search) {
		this.applyMMFilters();
	}

	toggleExpiredMMs() {
		this.applyMMFilters();
	}

	refreshData() {
		const filter = [];
		this.loadingPromos = true;
		this.loadingMMs = true;

		this.inventoryService.getPromos(filter).subscribe({
			next: r => {
				this.allpromos = r.promos;
				this.applyPromoFilters();
				this.loadingPromos = false;
			},
			error: () => { this.loadingPromos = false; }
		});

		this.inventoryService.getMixAndMatch(filter).subscribe({
			next: r => {
				this.mms = r;
				this.applyMMFilters();
				this.loadingMMs = false;
			},
			error: () => { this.loadingMMs = false; }
		});
	}

	closeMM() {
		this.newmm = false;
		this.editingmm = false;
		this.mm = false;
		this.exists = false;
		this.itemMMForm.reset();

		this.inventoryService.getMixAndMatch([]).subscribe(r => {
			this.mms = r;
			this.sortedMMs = r;
		});

	}

	sortTable(column: string) {
		if (this.sortColumn === column) {
			this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
		} else {
			this.sortColumn = column;
			this.sortDirection = 'asc';
		}

		this.sortedPromos.sort((a, b) => {
			let comparison = 0;

			if (a[column] > b[column]) {
				comparison = 1;
			} else if (a[column] < b[column]) {
				comparison = -1;
			}

			return this.sortDirection === 'asc' ? comparison : -comparison;
		});
	}

	getSortIcon(column: string): string {
		if (this.sortColumn === column) {
			return this.sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward';
		}
		return 'sort';
	}
	
	newPromo() {
		this.setForm();
		this.promoitems = false;
		this.newpromo = true;
		this.vendorSearchText = '';
		this.vendorresults = [];
		this.vendorPanelOpen = false;
	}

	sortMMTable(column: string) {
		if (this.mmSortColumn === column) {
			this.mmSortDirection = this.mmSortDirection === 'asc' ? 'desc' : 'asc';
		} else {
			this.mmSortColumn = column;
			this.mmSortDirection = 'asc';
		}

		this.sortedMMs.sort((a, b) => {
			let comparison = 0;

			if (a[column] > b[column]) {
				comparison = 1;
			} else if (a[column] < b[column]) {
				comparison = -1;
			}

			return this.mmSortDirection === 'asc' ? comparison : -comparison;
		});
	}

	// Method to get the appropriate Material icon for MM sorting
	getMMSortIcon(column: string): string {
		if (this.mmSortColumn === column) {
			return this.mmSortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward';
		}
		return 'sort';
	}

}